import { Dispatch } from 'redux';
import { actionCreators } from './MaintenanceState';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import { PreventiveMaintenanceRecord } from '../../Interfaces/Maintenance/PreventiveMaintenanceRecord';
import { PredictiveMaintenanceRecord } from '../../Interfaces/Maintenance/PredictiveMaintenanceRecord';

// Preventive Maintenance actions
export const fetchPrevMaintenanceRecords = async (
  dispatch: Dispatch<any>,
  includeCompleted: boolean
) => {
  return dispatch(actionCreators.fetchPrevMaintenanceRecords(includeCompleted));
};

export const updatePrevMaintenanceRecord = async (
  dispatch: Dispatch<any>,
  record: PreventiveMaintenanceRecord,
  newStatus: ApiEnums.PreventiveMaintenanceStatus
) => {
  return dispatch(
    actionCreators.updatePrevMaintenanceRecord(record, newStatus)
  );
};

// Predictive Maintenance actions
export const fetchPredMaintenanceRecords = async (
  dispatch: Dispatch<any>,
  includeCompleted: boolean
) => {
  return dispatch(actionCreators.fetchPredMaintenanceRecords(includeCompleted));
};

export const updatePredMaintenanceRecord = async (
  dispatch: Dispatch<any>,
  record: PredictiveMaintenanceRecord,
  newStatus: ApiEnums.PredictiveMaintenanceStatus
) => {
  return dispatch(
    actionCreators.updatePredMaintenanceRecord(record, newStatus)
  );
};

export const pingDMMTransferService = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.pingDMMTransferService());
};

export const resetFetchError = async (dispatch: any) => {
  return dispatch(actionCreators.resetFetchError());
};
